$(function () {
	var index = {
		init: function init() {
			this.video()
			this.yuyueOne()
			this.linkTo()
			this.yuyueTwo()
		},

		video: function () {
			TCPlayer('videoPlayerA', {
				fileID: '5285890817482472706',
				appID: '1259605108',
				autoplay: false,
			})
		},
		yuyueOne: function () {
			$('.second').listenForm({
				contentName: [
					{
						search: '?jtppzq',
						name: 'web中高考留学报名（百品）',
					},
					{
						search: '?360jtppzq',
						name: 'web中高考留学报名（360）',
					},
					{
						search: '',
						name: 'web中高考留学报名',
					},
					{
						search: '?tg',
						name: ' web中高考留学报名（推广）',
					},
				],
				submitTarget: '.toast_submit_btn',
				courseRequired: true,
				cityRequired: true,
			})
			new Bselector({
				showSelected: '#toastCity',
				inputSelected: '.toastCity',
				options: [
					{
						text: '北京市',
					},
					{
						text: '天津市',
					},
					{
						text: '上海市',
					},
					{
						text: '重庆市',
					},
					{
						text: '河北省',
					},
					{
						text: '河南省',
					},
					{
						text: '广东省',
					},
					{
						text: '辽宁省',
					},
					{
						text: '湖南省',
					},
					{
						text: '四川省',
					},
					{
						text: '安徽省',
					},
					{
						text: '山东省',
					},
					{
						text: '江苏省',
					},
					{
						text: '浙江省',
					},
					{
						text: '湖北省',
					},
					{
						text: '山西省',
					},
					{
						text: '陕西省',
					},
					{
						text: '福建省',
					},
					{
						text: '江西省',
					},
					{
						text: '广西省',
					},
					{
						text: '甘肃省',
					},
					{
						text: '黑龙江省',
					},
					{
						text: '内蒙古',
					},
					{
						text: '吉林省',
					},
					{
						text: '新疆维吾尔',
					},
					{
						text: '贵州省',
					},
					{
						text: '云南省',
					},
					{
						text: '青海省',
					},
					{
						text: '西藏',
					},
					{
						text: '宁夏回族',
					},
					{
						text: '海南省',
					},
				],
			})
			new Bselector({
				showSelected: '#toastCourse',
				inputSelected: '.toastCourse',
				options: [
					{
						text: '雅思',
					},
					{
						text: '托福',
					},
					{
						text: 'SAT',
					},
				],
			})
		},
		linkTo: function () {
			$('.linkTo').click(function () {
				var top1 = $('.second').offset().top
				$('html,body').animate({
					scrollTop: top1,
				})
			})
			$('.object .btn').click(function () {
				var top1 = $('.second').offset().top
				$('html,body').animate({
					scrollTop: top1,
				})
			})
			$('.footer .btn_two').click(function () {
				var top1 = $('.second').offset().top
				$('html,body').animate({
					scrollTop: top1,
				})
			})
		},
		yuyueTwo: function () {
			$('.gift').listenForm({
				contentName: [
					{
						search: '?jtppzq',
						name: 'web中高考领取资料（百品）',
					},
					{
						search: '?360jtppzq',
						name: '  web中高考领取资料（360）',
					},
					{
						search: '',
						name: ' web中高考领取资料',
					},
					{
						search: '?tg',
						name: '  web中高考领取资料（推广）',
					},
				],
				submitTarget: '#formBtn2',
				cityRequired: true,
			})
			new Bselector({
				showSelected: '#infoCity',
				inputSelected: '.info_city',
				options: [
					{
						text: '北京市',
					},
					{
						text: '天津市',
					},
					{
						text: '上海市',
					},
					{
						text: '重庆市',
					},
					{
						text: '河北省',
					},
					{
						text: '河南省',
					},
					{
						text: '广东省',
					},
					{
						text: '辽宁省',
					},
					{
						text: '湖南省',
					},
					{
						text: '四川省',
					},
					{
						text: '安徽省',
					},
					{
						text: '山东省',
					},
					{
						text: '江苏省',
					},
					{
						text: '浙江省',
					},
					{
						text: '湖北省',
					},
					{
						text: '山西省',
					},
					{
						text: '陕西省',
					},
					{
						text: '福建省',
					},
					{
						text: '江西省',
					},
					{
						text: '广西省',
					},
					{
						text: '甘肃省',
					},
					{
						text: '黑龙江省',
					},
					{
						text: '内蒙古',
					},
					{
						text: '吉林省',
					},
					{
						text: '新疆维吾尔',
					},
					{
						text: '贵州省',
					},
					{
						text: '云南省',
					},
					{
						text: '青海省',
					},
					{
						text: '西藏',
					},
					{
						text: '宁夏回族',
					},
					{
						text: '海南省',
					},
				],
			})
		},
	}
	index.init()
})
